/**
 * ServiceBasicInfoCard — the "Basic Information" card on the Service Detail
 * page. Purely presentational. Extracted from `routes/services/$serviceId.tsx`
 * (issue #1411).
 */
import { StatusBadge } from '../shared';
import type { Service } from '../../graphql/types';

const CardElement = 'forge-card' as React.ElementType;
const DividerElement = 'forge-divider' as React.ElementType;

export interface ServiceBasicInfoCardProps {
  service: Service;
}

export function ServiceBasicInfoCard({ service }: ServiceBasicInfoCardProps): JSX.Element {
  return (
    <CardElement className="service-card">
      <div className="card-header">
        <h2 className="forge-typography--headline6">Basic Information</h2>
      </div>
      <DividerElement />
      <div className="card-content">
        <div className="detail-row">
          <span className="detail-label">Service Type</span>
          <span className="detail-value">{service.serviceType}</span>
        </div>
        <div className="detail-row">
          <span className="detail-label">Lifecycle Status</span>
          <span className="detail-value">
            <StatusBadge variant="lifecycle" value={service.lifecycleStatus || 'development'} />
          </span>
        </div>
        <div className="detail-row">
          <span className="detail-label">Tier</span>
          <span className="detail-value">
            <StatusBadge variant="tier" value={service.tier} />
          </span>
        </div>
        <div className="detail-row">
          <span className="detail-label">Description</span>
          <span className="detail-value">{service.description || '—'}</span>
        </div>
      </div>
    </CardElement>
  );
}
